export const getStatusLabel = (status) => {
  const statusMap = {
    DRAFT: '임시저장',
    PENDING: '미확인',
    APPROVED: '승인',
    REJECTED: '미승인',
    SUSPENDED: '정지',
  };

  return statusMap[status] || status || '-';
};

export const getStatusClass = (status) => {
  if (status === 'APPROVED') return 'status-approved';
  if (status === 'PENDING') return 'status-pending';
  if (status === 'REJECTED') return 'status-rejected';
  if (status === 'SUSPENDED') return 'status-suspended';
  return '';
};
